(($) => {

    let nav = $('.nav');

    // nav menu open and close items on click, also close whole menu on larger screens

    // need to use headers search form & maybe an alternative close button or some code or something so it links to the nav as well as the search bar

    function coverNavMenuRun(){
        $('.primary_overlay').removeClass('active');
        nav.removeClass('active');
        nav.animate({ right: '-100%'}, 250, function(){
            nav.css('opacity', 0);
        });
        $('.nav_extra--alternative').removeClass('active');
        $('.nav_extra--primary').addClass('active');

        $('.nav_secondary').removeClass('active');
        $('.nav_secondary').animate({ left: '410px'}, 250, function(){
            $('.nav_secondary').css('opacity', 0);
        });

        $(".equipment_accordion__content").slideUp();
        $(".equipment_accordion__title").removeClass("active");

        $('.nav_tertiary__item').removeClass('active');
        $('.nav_tertiary__item').animate({ left: '410px'}, 250, function(){
            $('.nav_tertiary__item').css('opacity', 0);
        });

        $('body').removeClass('custom_lock');
        $('.mainbar__image').addClass('active');
        $('.mainbar__buttons__item--search_form').removeClass('active');
        $('.mainbar__buttons__item--mobile_menu_button').removeClass('active');
        $('.mainbar__buttons__item--search_button').addClass('active');
    }

    function closeNavMenu(){
        if(nav.css('right') == '0px' || $('.mainbar__buttons__item--search_form').hasClass('active')){
            coverNavMenuRun();
        }
        setTimeout(function(){
            if(nav.css('right') === '0px'){
                coverNavMenuRun();
            }
        }, 500);
    }

    $('.mainbar__buttons__item--mobile_menu_button').on('click', function(){
        if(nav.hasClass('active') || $('.mainbar__buttons__item--search_form').hasClass('active')){
            closeNavMenu();
        }
        else{
            if(nav.css('opacity') == 0){
                nav.addClass('active');
                nav.css('opacity', 1);
                nav.animate({ right: '0'}, 400);
                $('.primary_overlay').addClass('active');
                $('body').addClass('custom_lock');
                $('.mainbar__image').removeClass('active');
                $('.mainbar__buttons__item--search_form').addClass('active');
                $('.mainbar__buttons__item--mobile_menu_button').addClass('active');
                $('.mainbar__buttons__item--search_button').removeClass('active');
            }
        }
    });
    
    $('.mainbar__buttons__item--search_button').on('click', function(){
        $('.mainbar__image').removeClass('active');
        $('.mainbar__buttons__item--search_button').removeClass('active');
        $('.mainbar__buttons__item--search_form').addClass('active');
        $('.mainbar__buttons__item--mobile_menu_button').addClass('active');
    });

    $(window).on('resize', function(){
        if(window.innerWidth >= 1512){
            if(nav.hasClass('active')){
                closeNavMenu();
            }
        }
    });

    $('.primary_overlay').click(function(e){
        if(e.target === this){ 
            closeNavMenu();
        }
    });

    $('.nav_primary_button').on("click", function(){
        let classList = $(this).attr('class').split(' ');
        let modifierClass = classList.find(cls => cls.startsWith('nav_primary_button--'));
        $('.nav_extra').addClass('active');
        
        if(modifierClass){
            let modifier = modifierClass.replace('nav_primary_button', '');
            $('.nav_secondary' + modifier).addClass('active');
            $('.nav_secondary' + modifier).css('opacity', 1);
            $('.nav_secondary' + modifier).animate({ left: '0'}, 500);
        }
    });

    $('.nav_secondary__header').on("click", function(){
        $('.nav_secondary').removeClass('active');
        $('.nav_secondary').animate({ left: '410px'}, 500, function(){
            $('.nav_secondary').css('opacity', 0);
        });

        $(".equipment_accordion__content").slideUp();
        $(".equipment_accordion__title").removeClass("active");
    });

})(jQuery);